
import p1 from '../../media/basmala/p1.jpg'
import p2 from '../../media/basmala/p2.jpg'

const bassmalaMedia = {
    
    slide:[p1,p2]
}
export default bassmalaMedia